export enum TabsClientes {
  Dados = "dados",
  Financeiro = "financeiro",
}

export const TabMenuOptions: {
  label: string;
  route: TabsClientes;
  permissions: string[];
}[] = [
  {
    label: "Dados Cadastrais",
    route: TabsClientes.Dados,
    permissions: [],
  },
  {
    label: "Financeiro",
    route: TabsClientes.Financeiro,
    permissions: [],
  },
];
